import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Divider } from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import ProductassetInfo from '../ProductassetInfo';


export default function ProductassetListTableRow({ obj, getActionComponent, handleRowClick }) {
  useEffect(() => {
  }, [])
  return (

    <>
      <Grid item lg={12} sx={{ width: '100%' }}>
        {/* <ROW1 - CONTAINER/> */}
        <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
          sx={{
            cursor: 'pointer',
            justifyContent: "flex-start", alignItems: "center", padding: 1, backgroundColor: 'white',
            '&:hover': {
              backgroundColor: 'primary.100', color: 'primary.main'
            },
          }}>
          {/* <ROW1 - CELLS/> */}
          <Grid item lg={1} xs={2} >
            <div>
              <img src={obj.assetpath} alt="Selected" style={{ width: '50px', height: '50px' }} />
            </div>
          </Grid>
          <Grid item lg={3} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid>

          <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.designvendorname}</Typography></Grid>
          <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.orderedon}</Typography></Grid>
          <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.receivedon}</Typography></Grid>

          <Grid item lg={1} xs={2} >
            <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
              {getActionComponent(obj)}
            </Grid>
          </Grid>

        </Grid>
      </Grid>
      <Grid item lg={12} sx={{ width: '100%', borderBottom:'1px solid #d9d9d9' }}></Grid>
      {/* {
        obj.expand ?
          <Grid container direction="row">
            <Grid item sx={{ width: '100%' }}>
              < ProductassetInfo productassetObj={obj} />
            </Grid>
          </Grid>
          : <Grid container direction="row">
            <Grid item sx={{ width: '100%' }}>
              <Divider />
            </Grid>
          </Grid>
      } */}
    </>

  )
}